import { Component, Mixins, Prop } from 'vue-property-decorator';
import { UtilMixin } from '../../../UtilMixin';

@Component({ components: {} })
export default class LoansCountCard extends Mixins(UtilMixin) {
  @Prop() public tenant?: string;
  @Prop({ default: false }) public plain?: boolean;

  get from() {
    console.log('called from');
    return this.aYearAgoBegginingOfDayISOString();
  }

  get to() {
    console.log('called to');
    return this.begginingOfDayISOString();
  }

  public mounted() {
    console.log('mounted loans');
  }
}
